import "./css/ResponsiveFeatureVideoComponent.css"
import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'

export default class FeatureVideoComponent extends Component {
        render() {
                return (
                        <div id="videos-feature-container">
                                <Row>
                                        <Col lg={7} md={12}>
                                                <video className="intro-video" loop={true} preload="true" loading="lazy" playsInline autoPlay muted>
                                                        <source src='/video/analyze_it.mp4' type="video/mp4"></source>
                                                </video>
                                        </Col>
                                        <Col lg={5} md={12} className="pt-5" align="center">
                                                <p className="info-heading"><span className="text-primary">RESPONSIVE D</span>ESIGN</p>
                                                <p className="info-text-normal">Fully responsive and scalable dashboard design for best experience on phone and different screens</p>
                                                <p className="info-text-normal"></p>
                                        </Col>
                                </Row>
                        </div>
                )
        }
}
